import { Tag } from '@strata/react-tags';

interface ProductLabelProps {
    product?: string;
    isBrand?: boolean;
    isNonFormulary?: boolean;
}

export const ProductLabel = ({
    product = undefined,
    isBrand = false,
    isNonFormulary = false,
}: ProductLabelProps) => (
    <div className="flex__gap--medium" style={{ alignItems: 'center' }}>
        <span>{product}</span>
        {isBrand && <Tag label="Brand" style={{ flexShrink: 0 }} />}
        {isNonFormulary && <Tag intent={Tag.Intent.INFO} label="NF" style={{ flexShrink: 0 }} />}
    </div>
);
